import { activityFeed } from "./action";
import * as CONSTANT from "./constant";
const initial_state = {
  access: "",
  isHome: true,
  user_id: "",
  mobile: "",
  type: "",
  name: "",
  email: "",
  token: "",
  profile_pic: "",
  activitypage: 0,
  activityLength: 0,
  PasswordGenerate:'',
};
export default function reducer(state = initial_state, action) {
  switch (action.type) {
    case CONSTANT.LOGIN:
      console.log(action.token);

      return (state = {
        ...state,
        isHome: false,
        user_id: action.payload._id,
        mobile: action.payload.mobile,
        name: action.payload.name,
        profile_pic: action.payload.profile_pic,
        email: action.payload.email,
        token: action.token,
        type: action.payload.access,
      });
    case CONSTANT.PROFILEPIC:
      console.log(action.payload);

      return (state = {
        ...state,
        profile_pic: action.payload,
      });

    case CONSTANT.LOGOUT:
      return state = {
        ...state,
        isHome: true,
        user_id: '',
        mobile: '',
        name: '',
        email: '',
        token: '',
        type: '',
        profile_pic: ''
      };
      case CONSTANT.PASSWORD_GENERATE:
        // 
      
      return state = {
        ...state,
        PasswordGenerate: action.payload,
       
      };

       default:
      return state;
  }
}
